import { List } from 'antd';
import type { Identifier } from 'dnd-core';
import { JSX, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

export interface ICardProps {
	id: any;
	index: number;
	moveCard: (dragIndex: number, hoverIndex: number) => void;
	dropItem: (dragIndex: number, hoverIndex: number) => void;
	renderItem: (itemProps: any, index?: number) => JSX.Element;
	itemProps: any;
}

interface IDragItem {
	index: number;
	id: string;
	type: string;
}

const ListItem = (props: ICardProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const [{ handlerId }, drop] = useDrop<IDragItem, void, { handlerId: Identifier | null }>({
		accept: 'card',
		collect(monitor) {
			return {
				handlerId: monitor.getHandlerId()
			};
		},
		drop: (item: IDragItem) => {
			const dragIndex = item.index;
			const hoverIndex = props.index;
			props.dropItem(dragIndex, hoverIndex);
		},
		hover(item: IDragItem) {
			const dragIndex = item.index;
			const hoverIndex = props.index;

			// Don't replace items with themselves
			if (dragIndex === hoverIndex) {
				return;
			}

			// Time to actually perform the action
			props.moveCard(dragIndex, hoverIndex);

			// Note: we're mutating the monitor item here!
			// Generally it's better to avoid mutations,
			// but it's good here for the sake of performance
			// to avoid expensive index searches.
			item.index = hoverIndex;
		}
	});

	const [{}, drag] = useDrag({
		type: 'card',
		item: () => ({ id: props.id, index: props.index })
	});

	drag(drop(ref));

	return (
		<div
			ref={ref}
			data-handler-id={handlerId}
		>
			<List.Item key={props.index}>{props.renderItem(props.itemProps)}</List.Item>
		</div>
	);
};

export { ListItem };
